<template>
  <div class="page-container">
    <div
      class="row no-gutters border rounded overflow-hidden flex-md-row mb-4 p-0 shadow-sm h-md-250 position-relative"
    ></div>
  </div>
</template>

<script>
export default {
  name: 'Summery',
  data() {
    return {}
  }
}
</script>

<style scoped></style>
